export default "__VITE_ASSET__d120e8e3__"